import SentinelSerializer from 'admin-panel/serializers/sentinel';

export default class SentinelRoleSerializer extends SentinelSerializer {}

declare module 'ember-data/types/registries/serializer' {
  export default interface SerializerRegistry {
    'sentinel/role': SentinelRoleSerializer;
  }
}
